export class FactorSet
{
    id:number;
    transportModeId:number;
    deboardingValue:number;
    boarding1Value:number;
    boarding2Value:number;
    additionalId:number;
    additionalBoolean:boolean;
}
export class FactorSetSteps
{
    id:number;
    steps1Value:number;
    steps2Value:number;
    steps3Value:number;
    timeTypeId:number;
    additionalId:number;
}
export class FactorSetNaming
{
    id:number;
    name:string;
}


export const factorSetNaming:FactorSetNaming[]=[{id:1,name:'kia - FV'},{id:2,name:'kie1 - FV'},{id:3,name:'kie2 - FV'},{id:4,name:'kia - NV'},{id:5,name:'kie1 - NV'},{id:6,name:'kie2 - NV'},{id:7,name:'kia - UNV'},{id:8,name:'kie1 - UNV'},{id:9,name:'kie2 - UNV'}];
export const factorSetLuggageRacksWhenBoardingNaming:FactorSetNaming[]=[{id:1,name:'Without Rack'},{id:2,name:'With Rack'}];
export const factorSetReservationObligationNaming:FactorSetNaming[]=[{id:1,name:'Ja'},{id:2,name:'Nein'}];
export const factorSetCompartmentsAvailableNaming:FactorSetNaming[]=[{id:1,name:'Ja'},{id:2,name:'Nein'}];
export const factorSetStepsNaming:FactorSetNaming[]=[{id:1,name:'iSB,1'},{id:2,name:'iSB,2'},{id:3,name:'iSB,3'},{id:4,name:'aStB,1'},{id:5,name:'aStB,2'},{id:6,name:'aStB,3'}];
export const factorSetSeperationNaming:FactorSetNaming[]=[{id:1,name:'no separation'},{id:2,name:'one separation'},{id:3,name:'two separation'}];
